<template>
    <div class="plan-selection">
        <div class="backButton" v-if="showBackButton">
            <button class="btn btn-secondary w-45px mt-15 mb-15" @click="goBack">
                <v-icon>
                    fas fa-chevron-left
                </v-icon>
            </button>
        </div>
        <div class="plans" v-if="step<2">
            <div class="planContainer">
                <div class="white-box plan-selection__plan bg-light-grey text-black forhove" :class="{active: planType ==='growth'}" v-if="planType !== 'income'" @click="selectPlan('growth')">
                    <div class="d-flex mb-10">
                        <strong class="plan-selection__plan--value text-primary">18<small>%</small></strong>
                        <div class="plan-selection__plan--content">
                            <strong>GROWTH PLAN</strong>
                            <p class="mt-5 mb-0">Earn Up to 18% interest p.a </p>
                        </div>
                    </div>
                    <div class="plan-selection__plan--text pl-10">
                        <p>Monthly interest + principal repayments are reinvested to accrue compounding returns</p>
                        <p class="plan-selection__plan--product-detail mb-0" @click.stop="showProductDetails('growth')" >
                            <span class="sprite icon-info-blue mr-15"></span>
                            <span class="text-primary text-underline">Click here for product details &amp; risks</span>
                        </p>
                    </div>
                </div>
                <ProductDetailsDropdown
                    v-if="showProduct === 'growth'"
                    :display="showProduct"
                    @closeDialog="closeProductDetailsDialog"
                />
            </div>
            <div class="planContainer">
                <div class="white-box plan-selection__plan bg-light-grey text-black forhove" :class="{active:  planType ==='income'}" v-if="planType !== 'growth'" @click="selectPlan('income')">
                    <div class="d-flex mb-10">
                        <strong class="plan-selection__plan--value text-primary">16<small>%</small></strong>
                        <div class="plan-selection__plan--content">
                            <strong>INCOME PLAN</strong>
                            <p class="mt-5 mb-0">Earn Up to 16% interest p.a </p>
                        </div>
                    </div>
                    <div class="plan-selection__plan--text pl-10">
                        <p>Monthly interest payments are paid into your account and principal is reinvested for monthly returns.</p>
                        <p class="plan-selection__plan--product-detail mb-0" @click.stop="showProductDetails('income')">
                            <span class="sprite icon-info-blue mr-10"></span>
                            <span class="text-primary text-underline">Click here for product details &amp; risks</span>
                        </p>
                    </div>
                </div>
                <ProductDetailsDropdown
                    v-if="showProduct === 'income'"
                    :display="showProduct"
                    @closeDialog="closeProductDetailsDialog"
                />
            </div>

            <div class="risk-selection" v-if="planType">
                <div class="risk-selection--dropdown" @click="displayRisks = !displayRisks">
                    Choose Risk Category<v-icon class="font-size-16">fas fa-chevron-down</v-icon>
                </div>

                <div class="risk-selection__content" v-if="displayRisks">
                    <div class="risk-selection__content__plan" v-for="(item, index) in risks" :key="index" @click="selectRisk(item.riskType)">
                        <strong>{{item.percentage}}<small class="font-size-md"> %</small></strong>
                        <div class="risk-selection__content__plan--info">
                            <h2 class="mb-5">{{item.riskType}}</h2>
                            <p class="font-size-sm mb-10">{{item.riskDescription}}</p>
                        </div>
                    </div>
                </div>
                <small class="d-block mt-15">Don’t worry. You can always go back and change  or add another investment plan and risk category</small>
            </div>
        </div>
        <v-snackbar
            v-model="isFailure"
            app
            timeout="3000"
        >
            {{failureText}}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="isFailure = false"
                >
                Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import ProductDetailsDropdown from '../plans/productDetailsDropdown.vue'
import OnboardingService from '@/services/lenderOnboardingService.js'

import LenderService from '@/services/lenderService'

export default {
    name: 'PlanSelection',
    components: {
        ProductDetailsDropdown
    },
    props: {
        isCreatePortfolio: Boolean,
        currentPortfolio: Object,
        isEditPortfolio: Boolean,
        showAmountSelection: Boolean,
        isBackButtonVisible: Boolean
    },
    data () {
        return {
            planType: null,
            riskType: null,
            portfolio: null,
            displayRisks: false,
            amount: null,
            showProduct: null,
            step: 0,
            showBackButton: false,
            editPortfolio: false,
            creatingPortfolio: false,
            failureText: 'Something went wrong! Please try again',
            isFailure: false
        }
    },
    computed: {
        risks () {
            if (this.planType === 'growth') {
                return [
                    {
                        percentage: 14,
                        riskType: 'conservative',
                        riskDescription: 'Upto 14% Interest p.a.'
                    },
                    {
                        percentage: 18,
                        riskType: 'aggressive',
                        riskDescription: 'Upto 18% Interest p.a.'
                    }
                ]
            } else {
                return [
                    {
                        percentage: 12,
                        riskType: 'conservative',
                        riskDescription: 'Upto 12% Interest p.a.'
                    },
                    {
                        percentage: 16,
                        riskType: 'aggressive',
                        riskDescription: 'Upto 16% Interest p.a.'
                    }
                ]
            }
        }
    },
    mounted () {
        if (this.isEditPortfolio) {
            this.editPortfolio = true
            this.amount = this.currentPortfolio.investmentAmount / 100
        }
        if (this.isCreatePortfolio) {
            this.creatingPortfolio = true
        }
        if (this.isBackButtonVisible) {
            this.showBackButton = true
        }
        this.checkIfPlanExisting()
    },
    methods: {
        selectPlan (type) {
            if (!this.planType) {
                this.showBackButton = true
                this.planType = type
                this.step++
                this.$emit('planSelected')
            }
        },
        selectRisk (type) {
            if (!this.riskType) {
                this.riskType = type
                this.step++
                this.portfolio = {
                    planType: this.planType,
                    riskProfile: this.riskType,
                    investmentType: 'autoInvest',
                    investmentAmount: 0,
                    status: 'created'
                }
                if (this.creatingPortfolio) {
                    this.createPortfolio()
                } else if (this.editPortfolio) {
                    this.portfolio.portfolioId = this.$store.state.portfolio.portfolioId
                    this.updatePortfolio()
                }

                this.$emit('riskSelected', this.portfolio)
            }
        },
        manualInvestment () {
            const portfolio = {
                investmentType: 'manual'
            }
            this.$emit('portfolio', portfolio)
            this.success()
        },
        goBack () {
            if (!this.step) {
                this.$emit('goBack')
            } else {
                this.planType = null
                this.riskType = null
                this.displayRisks = false
                this.amount = null
                this.step--
            }
        },
        checkIfPlanExisting () {
            this.$store.commit('isLoading')
            LenderService.checkCreatedPortfolioExists().then((res) => {
                this.$store.commit('isNotLoading')
                if (res.status === 200) {
                    this.creatingPortfolio = false
                    this.editPortfolio = true
                    const existingPortfolio = {
                        planType: res.data.planType,
                        riskProfile: res.data.riskProfile,
                        investmentType: 'autoInvest',
                        investmentAmount: res.data.investmentAmount || 0,
                        status: res.data.status,
                        portfolioId: res.data._id
                    }
                    this.$store.commit('portfolio/setPortfolio', existingPortfolio)
                    this.$emit('portfolio', existingPortfolio)
                }
            })
        },
        async createPortfolio () {
            this.$store.commit('isLoading')
            await OnboardingService.createPortfolio(this.portfolio).then((res) => {
                if (res.status === 200) {
                    this.portfolio.portfolioId = res.data.portfolioId
                    this.portfolio.investmentAmount = this.amount ? (this.amount * 100) : 0
                    this.$emit('portfolio', this.portfolio)
                    this.success()
                } else {
                    this.step = 0
                    this.riskType = null
                    this.planType = null
                    this.portfolio = null
                    this.displayRisks = false
                    this.creatingPortfolio = true
                    this.editPortfolio = false
                }
            })
            this.$store.commit('isNotLoading')
        },
        async updatePortfolio () {
            this.$store.commit('isLoading')
            await LenderService.editPortfolio(this.portfolio).then(async (res) => {
                if (res.status === 200) {
                    this.portfolio.investmentAmount = this.amount * 100
                    this.$emit('portfolio', this.portfolio)
                    this.success()
                } else if (res.status === 409) {
                    this.step = 0
                    this.riskType = null
                    this.planType = null
                    this.portfolio = null
                    this.displayRisks = false
                    this.failureText = 'You have already selected this Plan!'
                    this.isFailure = true
                } else {
                    this.step = 0
                    this.riskType = null
                    this.planType = null
                    this.portfolio = null
                    this.displayRisks = false
                }
            })
            this.$store.commit('isNotLoading')
        },
        showProductDetails (type) {
            this.showProduct = type
        },
        closeProductDetailsDialog () {
            this.showProduct = null
        },
        success () {
            this.$emit('success', this.portfolio)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/sass/components/plan-selection.scss";

.planContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
}

.active {
    background-color: $primary !important;
    .plan-selection__plan--value,
    .plan-selection__plan--content,
    .plan-selection__plan--text {
        color: $white !important;
    }

    .plan-selection__plan--product-detail {
        .text-primary {
            color: $secondary !important;
        }

        .icon-info-blue {
            background-position: -47px -48px;
        }
    }
}

.register--label {
    font-size: $font-size-base;
    font-weight: $font-weight-medium;
    color: $primary;

}

.amount {
    font-size: 20px;
    font-weight: 550;
    letter-spacing: 2px;
}
</style>
